import { Action } from 'redux';
import * as _ from 'underscore';
import { UserNotificationState } from '../../app/state/UserNotificationState';
import { isGetUserNotificationsSucceededAction, isGetUserNotificationsFailedAction } from './actions/GetUserNotificationsAction';
import { isUpdateUserNotificationsStatusSucceedAction } from './actions/UpdateUserNotificationStatusAction';
import { isUpdateUnreadUserNotificationsAction } from './actions/UpdateUnreadUserNotificationsAction';
import { IUserNotification } from '../models/IUserNotification';
import { isDeleteUserNotificationsSucceedAction } from './actions/DeleteUserNotification';
import { NotificationDisplayMode } from '../components/NotificationPanel';
import { isCheckHasUnseenUserNotificationsSucceededAction } from './actions/CheckHasUnseenUserNotificationsAction';
import { isUpdateLastSeenUserNotificationSucceededAction } from './actions/UpdateLastSeenUserNotificationAction';


const initialState: UserNotificationState = {
  hasUnseenNotifications: false,
  notifications: null,
  unreadNotifications: {},
  notificationDisplayMode: NotificationDisplayMode.NotificationLoading
};

// TODO add other actions here lik delete/update
export function userNotificationsReducer(
  prevState: UserNotificationState = initialState,
  action: Action = null
): UserNotificationState {
  if (isGetUserNotificationsSucceededAction(action)) {
    return {
      hasUnseenNotifications: prevState.hasUnseenNotifications,
      notifications: action.notifications,
      unreadNotifications: prevState.unreadNotifications,
      notificationDisplayMode: NotificationDisplayMode.NotificationLoaded
    };
  } else if (isUpdateUserNotificationsStatusSucceedAction(action)) {
    const { notifications, unreadNotifications } = prevState;
    _.forEach(action.notificationIds, (id: string) => {
      notifications[id].read = action.isRead;
      if (_.has(unreadNotifications, id)) {
        unreadNotifications[id].read = action.isRead;
      }
    });
    return {
      hasUnseenNotifications: prevState.hasUnseenNotifications,
      notifications: notifications,
      unreadNotifications: _.clone(unreadNotifications),
      notificationDisplayMode: prevState.notificationDisplayMode
    };
  } else if (isDeleteUserNotificationsSucceedAction(action)) {
    return {
      hasUnseenNotifications: prevState.hasUnseenNotifications,
      notifications: _.omit(prevState.notifications, action.notificationIds),
      unreadNotifications: _.omit(prevState.unreadNotifications, action.notificationIds),
      notificationDisplayMode: prevState.notificationDisplayMode
    };
  } else if (isCheckHasUnseenUserNotificationsSucceededAction(action)) {
    return {
      ...prevState,
      hasUnseenNotifications: action.hasUnseenUserNotifications,
    };
  } else if (isUpdateLastSeenUserNotificationSucceededAction(action)) {
    return {
      ...prevState,
      hasUnseenNotifications: false
    };
  } else if (isUpdateUnreadUserNotificationsAction(action)) {
    return {
      hasUnseenNotifications: prevState.hasUnseenNotifications,
      notifications: prevState.notifications,
      unreadNotifications: _.pick(prevState.notifications, (value: IUserNotification) => !value.read),
      notificationDisplayMode: prevState.notificationDisplayMode
    };
  } else if (isGetUserNotificationsFailedAction(action)) {
    return {
      hasUnseenNotifications: prevState.hasUnseenNotifications,
      notifications: prevState.notifications,
      unreadNotifications: prevState.unreadNotifications,
      notificationDisplayMode: NotificationDisplayMode.NotificationLoadFailed
    };
  } else {
    return prevState;
  }
}
